<button (click)="onButtonClick($event)">{{title}}
  <img *ngIf="isLoading" src="assets/gifs/spinner.gif" />
</button>
